import { render, staticRenderFns } from "./PaymentCards.vue?vue&type=template&id=52034776&"
import script from "./PaymentCards.vue?vue&type=script&lang=js&"
export * from "./PaymentCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports